declare const mixpanel: any

export default class Mixpanel {
  static get enabled(): boolean {
    return typeof mixpanel !== 'undefined'
  }

  static track(event, properties) {
    if (Mixpanel.enabled) {
      mixpanel.track(event, properties)
    }
  }
}